export const stackedBarChartDataDashboard2 =[{
    name: 'Time at passport control',
    data: [15, 15, 14, 14, 13, 12, 12, 12, 13, 14, 14, 14, 15]
  }, {
    name: 'Time at baggage reclaim',
    data: [23, 22, 22, 21, 20, 19, 18, 19, 20, 20, 21, 22, 23]
  }]